import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear(); 
  return (
    <footer className="footer">
      <p className="text-center">© {currentYear} Nuveen, LLC. All rights reserved.</p>
    </footer>
  );
}

export default Footer;